import type { FaireProductEntity } from "../../entity_types/product";

export const p_meqqa3wgx3: FaireProductEntity = {
  token: "p_meqqa3wgx3",
  type: "product",
  name: "My Emotions Wheel",
  brandToken: "b_djgzg75ijy",
  brandName: "Open The Joy",
  imageUrl:
    "https://cdn.faire.com/fastly/1987eab6cc0ed76413987fa7f13b53355f8ac8258be74ad176c4d94e441b12a1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/91626a57365e882694fdad989faea33df53f8aa21524f280d7cfb59b8887cb62.jpeg",
    "https://cdn.faire.com/fastly/53ced5ff9160764d818e1e20378d2263f96c4aac0a913a4a2254cc87b96c19dc.jpeg",
    "https://cdn.faire.com/fastly/78cc85ce20be689264d5e625e185ef2d2e0b7fc1eb5df63e2d5c269ea325fbc8.jpeg",
    "https://cdn.faire.com/fastly/a38829b963e57e628479d9b1ac7804eb36e406a2af3fe57dd2b70f014e82e29b.jpeg",
  ],
  priceDollars: 18.98,
  description:
    "Help kids learn and express their feelings through play with this 3 in 1 Emotions Wheel Puzzle! Beautifully crafted from wood, this durable new toy includes 24 colorful pieces, a sturdy storage base, and 3 bonus games. This unique new toy is a puzzle, spinner, twisting track, and learning center all in one, giving kids endless ways to build, spin and play! \n\nWith 24 colorful wooden pieces and a sturdy base, puzzle, a spinner, and a learning center, crafted from 24 vibrant wooden pieces that fit into a sturdy storage base. Accompanied by 3 bonus games, it’s designed to engage children in recognizing and naming emotions through interactive play. Perfect for kids seeking to understand the wide range of human emotions, this educational tool not only helps in building emotional intelligence but also enhances fine motor skills and problem-solving abilities. As they build, spin, and play, children will discover endless opportunities to learn about their feelings and how to express them health",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:52.261Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
